import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ChevronLeft } from "lucide-react";

export default function GewinnspielTeilnahmebedingungen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5 py-12 px-4">
      {/* Das Gewinnspiel ist beendet (Sitzung „Aufräumen“, 14.10.2026); die Bedingungen bleiben für Teilnehmende lesbar. */}
      <Helmet>
        <title>Teilnahmebedingungen Gewinnspiel – MusiKonzept</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="container mx-auto max-w-3xl">
        <Button
          variant="ghost"
          className="mb-6 -ml-2"
          onClick={() => navigate("/gewinnspiel")}
        >
          <ChevronLeft className="mr-1 h-4 w-4" />
          Zurück zum Gewinnspiel
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-8">
          Teilnahmebedingungen
        </h1>

        <Card className="border-0 shadow-xl">
          <CardContent className="p-6 md:p-8 space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Veranstalter</h2>
              <p className="text-muted-foreground">
                MusiKonzept, vertreten durch Daniel Sommer, Lanker Straße 10, 40545 Düsseldorf, Deutschland. E-Mail: info@musikonzept.de, Telefon: 0211 / 33676286.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Teilnahmeberechtigung</h2>
              <p className="text-muted-foreground">
                Teilnahmeberechtigt sind registrierte MusiKonzept-Nutzerinnen und -Nutzer im kostenlosen Starter-Tarif, die eine persönliche Einladung zu dieser Aktion erhalten haben, mindestens 18 Jahre alt und unbeschränkt geschäftsfähig sind. Die Teilnahme ist nur über den persönlichen Einladungslink und pro Person einmalig möglich. Mitarbeitende des Veranstalters sowie mit der Durchführung betraute Personen sind von der Teilnahme ausgeschlossen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Teilnahmezeitraum</h2>
              <p className="text-muted-foreground">
                Die Aktion läuft fortlaufend. Der Veranstalter behält sich vor, die Aktion jederzeit ohne Vorankündigung zu ändern, zu unterbrechen oder zu beenden. Der persönliche Einladungslink ist 14 Tage ab Versand gültig. Nach der Teilnahme besteht eine Frist von 48 Stunden zur Einlösung des Vorteils.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Art der Teilnahme</h2>
              <p className="text-muted-foreground">
                Die Teilnahme erfolgt über den persönlichen Einladungslink auf der Gewinnspielseite durch Beantwortung einer kurzen Quizfrage. Nach korrekter Beantwortung wird der persönliche Vorteil angezeigt und kann eingelöst werden.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Gewinn / Vorteil</h2>
              <p className="text-muted-foreground">
                Der Vorteil besteht in einer dauerhaft vergünstigten MusiKonzept-Mitgliedschaft: Nach einer 14-tägigen Testphase für 1 € beträgt der Mitgliedsbeitrag dauerhaft 19 € oder 25 € pro Monat (statt regulär 39 € pro Monat). Die jeweilige Variante wird automatisch zugeteilt. Der vergünstigte Preis bleibt erhalten, solange die Mitgliedschaft ununterbrochen aktiv ist.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Abwicklung</h2>
              <p className="text-muted-foreground">
                Der Vorteil wird als automatischer Rabatt im Checkout gewährt; ein gesonderter Gutscheincode ist nicht erforderlich. Die Einlösung muss innerhalb von 48 Stunden nach der Teilnahme erfolgen. Die Mitgliedschaft ist monatlich kündbar. Ergänzend gelten die Allgemeinen Geschäftsbedingungen (AGB) von MusiKonzept.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Datenschutz-Hinweis</h2>
              <p className="text-muted-foreground">
                Die im Rahmen der Teilnahme erhobenen Daten werden ausschließlich
                zur Durchführung der Aktion verarbeitet. Weitere Informationen
                findest du in unserer{" "}
                <a href="/datenschutz" className="underline hover:text-primary">
                  Datenschutzerklärung
                </a>
                .
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Sonstiges</h2>
              <p className="text-muted-foreground">
                Der Rechtsweg ist ausgeschlossen. Eine Barauszahlung oder Übertragung des Vorteils auf Dritte ist nicht möglich. Die Teilnahme ist kostenlos und unabhängig vom Erwerb von Waren oder Dienstleistungen. Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser Teilnahmebedingungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
